import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { SocketProvider } from './contexts/SocketContext'; // Import SocketProvider

// Import the API configuration
import { API_BASE_URL } from './utils/apiConfig';

// Set default base URL for all axios requests
axios.defaults.baseURL = API_BASE_URL;

// Determine if we're in production environment
const isProduction = process.env.NODE_ENV === 'production';

// Add interceptors to handle errors
axios.interceptors.response.use(
  response => response,
  error => {
    console.error('Axios request error:', error);

    // Check for 401 Unauthorized (e.g., expired JWT)
    if (error.response && error.response.status === 401) {
      console.log('Authentication error (401): Token expired or invalid. Logging out.');
      // Remove token from local storage
      localStorage.removeItem('token');
      // Redirect to login page
      // Avoid infinite loops if the login page itself causes a 401
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
        // Optionally show a message to the user (e.g., using a toast notification library if available)
        // alert('Your session has expired. Please log in again.');
      }
      // Return a resolved promise to prevent further error handling for this specific case
      return Promise.resolve({ data: { message: 'Session expired' } });
    }
    
    // Add specific handling for server connection issues
    if (error.code === 'ERR_NETWORK') {
      if (isProduction) {
        console.error('Network error: API server connection issue');
        // No alert in production - just log the error
      } else {
        console.error('Network error: Backend server may not be running at http://localhost:5005');
        alert('Connection error: Backend server may not be running. Please start the server and try again.');
      }
    }
    
    return Promise.reject(error);
  }
);

// Perform a health check to ensure the backend is running
axios.get('/api/db-check')
  .then(response => {
    console.log('Backend server is running:', response.data);
  })
  .catch(error => {
    console.error('Backend server check failed:', error);
    if (error.code === 'ERR_NETWORK' && !isProduction) {
      alert('Backend server is not running. Please start the server at http://localhost:5005');
    }
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SocketProvider> {/* Wrap App with SocketProvider */}
      <App />
    </SocketProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
